import { Script } from "gatsby"
import { useCookieConsent } from "@hooks/use-cookie-consent"

const Driftt = () => {
  const { hasFunctionalCookieConsent } = useCookieConsent()

  const driftFunction = (
    <Script type="text/javascript">
      {`
      "use strict";

      function loadDriftWidget() {
        var t = window.driftt = window.drift = window.driftt || [];
        if (!t.init) {
          if (t.invoked) return void (window.console && console.error && console.error("Drift snippet included twice."));
          t.invoked = !0, t.methods = [ "identify", "config", "track", "reset", "debug", "show", "ping", "page", "hide", "off", "on" ],
            t.factory = function(e) {
              return function() {
                var n = Array.prototype.slice.call(arguments);
                return n.unshift(e), t.push(n), t;
              };
            }, t.methods.forEach(function(e) {
              t[e] = t.factory(e);
            }), t.load = function(t) {
              var e = 3e5, n = Math.ceil(new Date() / e) * e, o = document.createElement("script");
              o.type = "text/javascript", o.async = !0, o.crossorigin = "anonymous", o.src = "https://js.driftt.com/include/" + n + "/" + t + ".js";
              var i = document.getElementsByTagName("script")[0];
              i.parentNode.insertBefore(o, i);
            };
        }
        drift.SNIPPET_VERSION = '0.3.1';
        drift.load('x2ugb2nh7dxy');
        var random = Math.floor(Math.random() * (100 - 1)) + 1;
        if( random <= 50 ) {
          document.cookie = "DriftPlaybook=A";
        }
        else {
          document.cookie = "DriftPlaybook=B";
        }
      };
      loadDriftWidget();
      `}
    </Script>
  )

  // If the 'OptanonConsent' cookie exist and the 'func' permission is true (the user permitted the functionality cookie) => we load drift
  if (hasFunctionalCookieConsent) {
    return driftFunction
  }
  return null
}
export default Driftt

export const assignRandomDriftPlaybook = () => {
  function getRandomInt(min, max) {
    min = Math.ceil(min)
    max = Math.floor(max)
    return Math.floor(Math.random() * (max - min)) + min
  }

  var random = getRandomInt(1, 100)

  if (random <= 50) {
    document.cookie = "DriftPlaybook=A"
  } else {
    document.cookie = "DriftPlaybook=B"
  }
}
